import React from 'react'
import HeroSection from '../OutletTemplate/HeroSection'
import CaseStudiesSection from '../HomeLanding/ComponentsIndiaPage/CaseStudiesSection'
import NewFaqSection from '../HomeLanding/HomeLandingComponents/NewFaqSection'
import NewsAndVideos from '../HomeLanding/ComponentsIndiaPage/NewsAndVideos'
import FeaturesSection from '../OutletTemplate/FeaturesSection'
import styles from '../.././styles/outletTemplate.module.css'
import GetFreeTrial from '../OutletTemplate/GetFreeTrial'
import ReviewsSection from '../HomeLanding/ComponentsIndiaPage/ReviewsSection'
import BusinessUnlockSection from '../HomeLanding/ComponentsIndiaPage/BusinessUnlockSection'
import ConnectWithUs from '../HomeLanding/ComponentsIndiaPage/ConnectWithUs'
import { MarqueeComponentHomePage, NewMarqueeComponentHomePageIndia } from '../qbStrap'
import Image from 'next/image'

const LuggageStore = () => {
    const topSection = [
        {
            title: <>POS Billing Software for Luggage Bag Stores</>,
            text: "Every journey begins with the right bag, and the right technology to sell it. QueueBuster’s POS Billing Software for luggage Bag Stores helps you manage billing, stock, seasonal offers, and customer loyalty programs in just a few taps. It’s time to replace the chaos of manual processes with the confidence of smooth, efficient retail operations.",
            centerImage: "/assets/luggageStore/luggage_main.webp",
            height: "32rem",
            width: "53.6rem",
            top: "-17rem",

            Image1: {
                src: "/assets/watchStore/stocks.svg",
                alt: " luggage Store Image 1",
                width: "15rem",
                height: "6rem",
                right: "9rem",
                bottom: "16rem",


            },
            Image2: {
                src: "/assets/watchStore/quick_bill.svg",
                alt: "luggage Store Image 2",
                width: "12rem",
                height: "13rem",
                bottom: "21rem",
                right: "29rem",

            },
            Image3: {
                src: "/assets/watchStore/Schedule.svg",
                alt: "luggage Store Image 3",
                width: "22rem",
                height: "8rem",
                bottom: "8rem",
                left: "15rem",

            },
            Image4: {
                src: "/assets/luggageStore/spinner.svg",
                alt: "luggage Store Image 4",
                width: "16rem",
                height: "19rem",
                bottom: "17rem",
                left: "30rem",

            },
            Image5: {
                src: "/assets/watchStore/gift.svg",
                alt: "luggage Store Image 5",
                width: "6rem",
                height: "6rem",
                bottom: "18rem",
                left: "20rem",

            },
            Image6: {
                src: "/assets/luggageStore/Frame_luggage.svg",
                alt: "luggage Store Image 6",
                width: "4rem",
                height: "4rem",
                bottom: "24rem",
                right: "23rem",

            },


        }
    ]

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                 Why is this POS software good for luggage bag stores?
                </span>
            ),
            des: "Because it helps you manage fast billing, detailed stock tracking, offers, and customer retention, all in one simple solution.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I track different categories like travel bags, school bags, or laptop bags separately?
                </span>
            ),
            des: "Yes, you can sort and manage inventory across categories and subcategories with ease.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                 Can I run seasonal or travel-themed offers?
                </span>
            ),
            des: "Of course! Create and automate promotions during school admissions, summer breaks, or festive seasons.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Is it suitable for single-brand outlets and multi-brand showrooms?
                </span>
            ),
            des: "Yes. Whether you run one store or multiple branches, QueueBuster works seamlessly across all.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   What payment modes are accepted?
                </span>
            ),
            des: "You can accept payments via UPI, credit/debit cards, mobile wallets, and cash, all through one platform.",
            id: 5,
            activeIndex: 0,
        },

    ]
    const watchStoreFeatures = {
        centerImage2: "/assets/luggageStore/luggageStore_image.webp",
        data: [
            {
                id: 1,
                image: "/assets/luggageStore/Smoothbilling.webp",
                icon: "/assets/petStore/Point_of_sale.svg",
                title: "Smooth billing for every style and size",
                tag: "Point of Sale",
                desc: "Whether you’re selling cabin luggage, trekking backpacks, or trendy laptop bags, QueueBuster makes billing quick and hassle-free, online or in-store.",
                btnText: "Speak with an expert",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                 Image1: {
                    src: "/assets/luggageStore/myton.svg",
                    alt: "Pet Store Image 2",
                    imageWidth: "20rem",
                    imageHeight: "9rem",
                    right: "3rem",
                    bottom: "4rem",

                },
                Image3: {
                    src: "/assets/luggageStore/Bill_spinner.svg",
                    alt: "watch Store Image",
                    imageWidth: "22rem",
                    imageHeight: "16rem",
                    top: "5rem",
                    left: "3rem",
                },

                points: [
                    <>Generate bills quickly for multiple items or combos</>,
                    <>Accept UPI, cards, wallets, or cash </>,
                    <>Easy returns and exchanges with digital history </>,
                ],
            },
            {
                id: 2,
                image: "/assets/luggageStore/backpack.webp",
                tag: "Inventory Management",
                icon: "/assets/petStore/Inventory.svg",
                title: "Track every backpack, suitcase, and sling",
                desc: "Never miss a restock or overstock again. Manage your inventory of different brands, sizes, and styles with ease.",
                btnText: "Request a callback",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                 Image1: {
                    src: "/assets/luggageStore/stock.svg",
                    imageWidth: "18rem",
                    imageHeight: "6rem",
                    bottom: "0rem",
                    right: "8rem",
                     
                },
                Image3: {
                    src: "/assets/luggageStore/daily.svg",
                    alt: "Pet Store Image 2",
                    imageWidth: "18rem",
                    imageHeight: "12rem",
                    left: "0rem",
                    top: "9rem",
                },
                
                 

                points: [
                    <>Monitor stock for luggage sets, laptop bags, trolleys, etc. </>,
                    <>Get alerts for low-stock or high-demand items </>,
                    <>Record size, material, color, and warranty info</>,
                    <>Manage suppliers, purchase orders, and reorder levels</>,
                ],
            },
            {
                id: 3,
                image: "/assets/luggageStore/online.webp",
                tag: "eStore",
                icon: "/assets/petStore/loyalty_new.svg",
                 title: "Manage online orders effortlessly",
                desc: "Offer a seamless shopping experience to your digital customers. With QueueBuster’s eStore integration, you can manage online orders, billing, and inventory from a single platform, no more juggling between systems.",
                imageWidth: "48rem",
                imageHeight: "40.3rem",
                btnText: "Talk to an expert",
                Image1: {
                    src: "/assets/luggageStore/addtocart.svg",
                    alt: "watch Store Image 4",
                    imageWidth: "13rem",
                    imageHeight: "19rem",
                    top: "5rem",
                    right: "3rem",
                    
                },
                Image3: {
                    src: "/assets/luggageStore/buyone.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "22rem",
                    imageHeight: "9rem",
                    bottom: "0rem",
                    left: "4rem",
                     
                },
                
                points: [
                    <>Process eStore orders with real-time billing</>,
                    <>Auto-generate and share digital invoices</>,
                    <>Sync online sales with inventory instantly</>,
                    <>Handle festive spikes and flash sales without delays</>
                ],
            },
            {
                id: 4,
                image: "/assets/luggageStore/Understand.webp",
                tag: "Reports & Analytics",
                icon: "/assets/luggageStore/analytics.svg",
                title: "Understand trends, boost performance",
                desc: "With easy-to-understand reports, know what luggage sells best, who your top-performing staff are, and what hours see maximum footfall.",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                btnText: "Request a callback",
                
                Image1: {
                    src: "/assets/luggageStore/reports.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "20rem",
                    imageHeight: "20rem",
                    bottom: "3rem",
                    right: "-1rem",
                    
                },
                 Image3: {
                    src: "/assets/luggageStore/customersLS.svg",
                    alt: "Watch Store Image 4",
                    imageWidth: "15rem",
                    imageHeight: "6rem",
                    top: "4rem",
                    left: "40%",
                    transform: "translateX(-40%)",
                },
                Image4: {
                    src: "/assets/luggageStore/Text.svg",
                    alt: "Pet Store Image 3",
                    imageWidth: "20rem",
                    imageHeight: "6rem",
                    bottom: "15rem",
                    left: "0rem",
                     
                },
                points: [
                    <>Track bestselling brands, models, and materials</>,
                    <>Monitor daily sales, staff performance, and returns</>,
                    <>Check GST and tax summaries in a single click</>,
                    <>Receive regular performance emails or summaries</>,
                ],
            },
              {
                id: 5,
                image: "/assets/luggageStore/customersLS.webp",
                tag: "Loyalty & CRM",
                icon: "/assets/petStore/loyalty_new.svg",
                title: "Make customers come back for their next trip",
                desc: "Delight your customers with points, perks, and personalized offers. From birthday discounts to VIP access on new arrivals, keep them coming back for more.",
                imageWidth: "42rem",
                imageHeight: "40.3rem",
                btnText: "Request a callback",
                Image1: {
                    src: "/assets/luggageStore/american.svg",
                    alt: "Watch Store Image 4",
                    imageWidth: "16rem",
                    imageHeight: "12rem",
                    top: "20rem",
                    right: "0rem",
                    
                },
                Image3: {
                    src: "/assets/luggageStore/activeLS.svg",
                    alt: "Watch Store Image 4",
                    imageWidth: "18rem",
                    imageHeight: "14rem",
                    top: "10rem",
                    left: "0rem",
                    
                },
                Image4: {
                    src: "/assets/luggageStore/100days.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "26rem",
                    imageHeight: "6rem",
                    bottom: "6rem",
                    left: "0rem",
                   
                    
                },
                points: [
                    <>Store customer data and purchase history securely</>,
                    <>Run loyalty programs with reward points.</>,
                    <>Send custom offers via SMS or WhatsApp.</>,
                ],
            },
        ]
    };
     const CompanyLogos = [
    { imgSrc: "/assets/HomeLanding/QBIcons/heineken.svg", height:"10rem",width:"15rem", altText: "Heineken" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bridgestone.svg",height:"10rem",width:"15rem", altText: "Bridgestone" },
    { imgSrc: "/assets/HomeLanding/QBIcons/itc.svg",height:"10rem",width:"15rem", altText: "ITCLimited" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tajseats.svg",height:"10rem",width:"15rem", altText: "TajSats1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/irctc.svg",height:"10rem",width:"15rem",  altText: "irctc" },
    { imgSrc: "/assets/HomeLanding/QBIcons/cremica.svg",height:"10rem",width:"15rem",  altText: "Cremica" },
    { imgSrc: "/assets/HomeLanding/QBIcons/pansarigroup.svg",height:"10rem",width:"15rem",  altText: "PansariGroup" },
    { imgSrc: "/assets/HomeLanding/QBIcons/reshamandi.svg",height:"10rem",width:"15rem",  altText: "Reshamandi1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/selectcitywalk.svg",height:"10rem",width:"15rem", altText: "SelectCitywalk" },
    { imgSrc: "/assets/HomeLanding/QBIcons/cococart.svg",height:"10rem",width:"15rem", altText: "Cococart" },
    { imgSrc: "/assets/HomeLanding/QBIcons/emoi.svg",height:"10rem",width:"15rem", altText: "Emoi" },
    { imgSrc: "/assets/HomeLanding/QBIcons/candorfoods.svg",height:"10rem",width:"15rem",  altText: "CandorFoods" },
    { imgSrc: "/assets/HomeLanding/QBIcons/TirumalaTirupatiDevasthanams.svg",height:"10rem",width:"15rem",  altText: "TirumalaTirupatiDevasthanams" },
    { imgSrc: "/assets/HomeLanding/QBIcons/earthrhythm.svg",height:"10rem",width:"15rem",  altText: "ArthRhythm1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/hindustanunilever.svg",height:"10rem",width:"15rem",  altText: "HindustanUnileverLimited" },
    { imgSrc: "/assets/HomeLanding/QBIcons/genus.svg",height:"10rem",width:"15rem", altText: "Genus" },
    { imgSrc: "/assets/HomeLanding/QBIcons/dlfbrands.svg",height:"10rem",width:"15rem", altText: "DLFbrands" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bayarscoffee.svg",height:"10rem",width:"15rem",  altText: "scoffee" },
    { imgSrc: "/assets/HomeLanding/QBIcons/continentalcoffee.svg",height:"10rem",width:"15rem", altText: "Continentalcoffee" },
    { imgSrc: "/assets/HomeLanding/QBIcons/plazalounge.svg",height:"10rem",width:"15rem", altText: "Plazapremiumlounge" },
    { imgSrc: "/assets/HomeLanding/QBIcons/mmmart.svg",height:"10rem",width:"15rem", altText: "Mart" },
    { imgSrc: "/assets/HomeLanding/QBIcons/wonderla.svg",height:"10rem",width:"15rem", altText: "wonderla" },
    { imgSrc: "/assets/HomeLanding/QBIcons/shivalaya1.svg",height:"10rem",width:"15rem", altText: "Shivalaya 1" },
    
   
]
const companyLogos2= [
     { imgSrc: "/assets/HomeLanding/QBIcons/organicharvest.svg", width:"15rem", height:"10rem", altText: "OrganicHarvest" },
    { imgSrc: "/assets/HomeLanding/QBIcons/nayara.svg",width:"15rem", height:"10rem", altText: "NayaraEnergy" },
    { imgSrc: "/assets/HomeLanding/QBIcons/premier.svg",height:"10rem",width:"15rem", altText: "Premier1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/orgalife.svg",height:"10rem",width:"15rem", altText: "Orgalife1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/smytten.svg",height:"10rem",width:"15rem", altText: "Smytten1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/flemingo.svg",height:"10rem",width:"15rem", altText: "Flemingo1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/aafarin.svg",height:"10rem",width:"15rem", altText: "Aafarin" },
    { imgSrc: "/assets/HomeLanding/QBIcons/redivy.svg",height:"10rem",width:"15rem", altText: "RedIvy1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/toscee.svg",height:"10rem",width:"15rem",  altText: "Toscee1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/jainshikanji.svg",height:"10rem",width:"15rem", altText: "Jainshikanji" },
    { imgSrc: "/assets/HomeLanding/QBIcons/34chowringlane.svg",height:"10rem",width:"15rem", altText: "34chowringheelane" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tangelo.svg",height:"10rem",width:"15rem", altText: "Tangelo1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/canabeans.svg",height:"10rem",width:"15rem", altText: "Canabeans1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/thegulatigroup.svg",height:"10rem",width:"15rem",altText: "gulatigroup" },
    { imgSrc: "/assets/HomeLanding/QBIcons/gullynetwork.svg", height:"10rem",width:"15rem", altText: "Gullynetwork1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/mcd.svg",height:"10rem",width:"15rem", altText: "MCD1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/phl.svg",height:"10rem",width:"15rem", altText: "PHL1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tistabene.svg",height:"10rem",width:"15rem", altText: "Tistabene1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/hokmakeup.svg",height:"10rem",width:"15rem", altText: "HOKmakeup1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/handfulofhealth.svg",height:"10rem",width:"15rem", altText: "Handfulofhealth" },
    { imgSrc: "/assets/HomeLanding/QBIcons/grihasthee.svg",height:"10rem",width:"15rem", altText: "grihasthee1" },
    // { imgSrc: "/assets/HomeLanding/QBIcons/relaxo.svg",height:"10rem",width:"15rem", altText: "relaxo" },
]
  


    return (
        <div style={{fontFamily:"GilroyMedium"}}>
            <HeroSection data={topSection} />
           <div style={{ maxWidth: "1850px", margin:"0 auto"}}>
              <div style={{ margin: "0rem 18rem 0 18rem", position: "relative", zIndex:1 }}>
                            <NewMarqueeComponentHomePageIndia
                             direction={'left'}
                                ClientsArr={CompanyLogos}
                                style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "2rem auto",
                                }}
                            />
                            <NewMarqueeComponentHomePageIndia
                                ClientsArr={companyLogos2}
                                  
                                style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "-3.5rem auto 0 auto",
                               
        
                                }}
                            />
                        </div>
           </div>

           <div className={styles.features_section}>
                <div className={styles.section_heading}><h1>Standout Features of  <span style={{color:"#2A6AB4"}}> QueueBuster POS for Luggage Bag Stores </span></h1>
                {/* <div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div> */}
                </div>

            
            <FeaturesSection data={watchStoreFeatures.data} centerImages={[watchStoreFeatures.centerImage2]} />
            </div>
            <div className={styles.featuresSection}>
                {/* <GetFreeTrial/> */}
                <div><ReviewsSection /></div>
                <div><BusinessUnlockSection /></div>
                <div><CaseStudiesSection /></div>
                <div style={{ margin: "0 0rem 8rem 0rem " }}> <ConnectWithUs /></div>
                
                <NewFaqSection FaqTableData={faqs} heading ={"FAQ’s for the QueueBuster POS fashion watch stores"}  />
                <div >
                    <NewsAndVideos />
                </div>
            </div>

        </div>
    )
}



export default LuggageStore
